var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.208L11.583 30.625C11.2777 30.9303 10.9097 31.083 10.479 31.083C10.0483 31.083 9.68032 30.9303 9.37499 30.625C9.06966 30.3197 8.91699 29.9517 8.91699 29.521C8.91699 29.0903 9.06966 28.7223 9.37499 28.417L17.792 20L9.37499 11.583C9.06966 11.2777 8.91699 10.9097 8.91699 10.479C8.91699 10.0483 9.06966 9.68033 9.37499 9.37499C9.68033 9.06966 10.0483 8.91699 10.479 8.91699C10.9097 8.91699 11.2777 9.06966 11.583 9.37499L20 17.792L28.417 9.37499C28.7223 9.06966 29.0903 8.91699 29.521 8.91699C29.9517 8.91699 30.3197 9.06966 30.625 9.37499C30.9303 9.68033 31.083 10.0483 31.083 10.479C31.083 10.9097 30.9303 11.2777 30.625 11.583L22.208 20L30.625 28.417C30.9303 28.7223 31.083 29.0903 31.083 29.521C31.083 29.9517 30.9303 30.3197 30.625 30.625C30.3197 30.9303 29.9517 31.083 29.521 31.083C29.0903 31.083 28.7223 30.9303 28.417 30.625L20 22.208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cc467af60ca651a92bfca93586bf8b10.svg";
export { ForwardRef as ReactComponent };